import { useField } from "vee-validate";
import { computed, reactive } from "vue";

/**
 * Adapts a VeeValidate field to the IModal interface expected by TextInput/PasswordInput.
 * Must be called inside <script setup> within a useForm context.
 */
export function useVeeField<T = string>(name: string) {
  const { value, errorMessage } = useField<T>(name);

  return reactive({
    get $model() {
      return value.value;
    },
    set $model(v: T) {
      value.value = v;
    },
    get $error() {
      return !!errorMessage.value;
    },
    get $errors() {
      return errorMessage.value ? [{ $message: errorMessage.value }] : [];
    },
  });
}

/**
 * EXCLUSIVO DO MAIN: erros do schema no formato que o FormButton lê (`$silentErrors`),
 * para o botão desabilitado mostrar o primeiro erro (balão e toast no celular),
 * como acontecia com o vuelidate.
 */
export function useSilentErrors(
  schema: { safeParse: (v: unknown) => { success: boolean; error?: { issues: { message: string }[] } } },
  values: Record<string, unknown>,
) {
  return computed(() => {
    const result = schema.safeParse(values);
    return {
      $silentErrors: result.success
        ? []
        : (result.error?.issues ?? []).map((i) => ({ $message: i.message })),
    };
  });
}
